export default "/_next/static/media/tem2.230440acec20a2106d8d39d649448788.jpg";